import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useConversations, filterConversationsByTab } from './useConversations';
import ChatListItem from './ChatListItem';
import { ChatListSkeleton } from '../UI/Skeleton';
import './Chat.css';

export default function ChatList({ currentUserId, defaultTab }) {
  const { t } = useTranslation();
  const [retryTrigger, setRetryTrigger] = useState(0);
  const [activeTab, setActiveTab] = useState(defaultTab || 'all');

  const { conversations, loading, error } = useConversations(currentUserId, retryTrigger);
  const filteredConversations = filterConversationsByTab(conversations, activeTab, currentUserId);

  useEffect(() => {
    if (defaultTab) setActiveTab(defaultTab);
  }, [defaultTab]);

  const renderTabs = () => (
    <div className="chatListTabs">
      <button type="button" className={`chatListTab${activeTab === 'all' ? ' active' : ''}`} onClick={() => setActiveTab('all')}>{t('common.all')}</button>
      <button type="button" className={`chatListTab${activeTab === 'buying' ? ' active' : ''}`} onClick={() => setActiveTab('buying')}>{t('chat.buying')}</button>
      <button type="button" className={`chatListTab${activeTab === 'selling' ? ' active' : ''}`} onClick={() => setActiveTab('selling')}>{t('chat.selling')}</button>
    </div>
  );

  if (!currentUserId) {
    return (
      <>
        <div className="messagesSidebarHeader">{t('dashboard.messages')}</div>
        <div className="messagesEmpty"><p>{t('chat.loginToViewMessages')}</p></div>
      </>
    );
  }
  if (error) {
    return (
      <>
        <div className="messagesSidebarHeader">{t('dashboard.messages')}</div>
        {renderTabs()}
        <div className="messagesEmpty messagesError">
          <p>{error}</p>
          <button type="button" className="chatRetryBtn" onClick={() => setRetryTrigger((t) => t + 1)}>{t('common.retry')}</button>
        </div>
      </>
    );
  }
  if (loading) {
    return (
      <>
        <div className="messagesSidebarHeader">{t('dashboard.messages')}</div>
        {renderTabs()}
        <ChatListSkeleton />
      </>
    );
  }

  const getEmptyMessage = () => {
    if (activeTab === 'buying') return t('chat.noBuyingConversations');
    if (activeTab === 'selling') return t('chat.noSellingConversations');
    return t('chat.noConversationsYet');
  };

  if (filteredConversations.length === 0) {
    return (
      <>
        <div className="messagesSidebarHeader">{t('dashboard.messages')}</div>
        {renderTabs()}
        <div className="messagesEmpty"><p>{getEmptyMessage()}</p></div>
      </>
    );
  }

  return (
    <>
      <div className="messagesSidebarHeader">{t('dashboard.messages')}</div>
      {renderTabs()}
      <ul className="chatList">
        {filteredConversations.map((conv) => (
          <ChatListItem key={conv.id} conv={conv} currentUserId={currentUserId} activeTab={activeTab} />
        ))}
      </ul>
    </>
  );
}
